// extracted by mini-css-extract-plugin
export var expandableCategorisedTable = "ExpandableCategorisedProductTable-module--expandableCategorisedTable--7F-iV";
export var noProducts = "ExpandableCategorisedProductTable-module--noProducts--MxRYs";